<template>
    <div class="buyerInviteDetailWrap">
        <div class="searchBox">
            <div class="left">
               受 {{userName}} 邀请总人数：共 位
            </div>
            <div class="right">
                <el-form :inline="true">
                    <el-form-item>
                       <el-button type="primary">下载列表</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="tableBox">
            <el-table v-loading="isLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)" ref="multipleTable" border stripe :data="tableData"
                tooltip-effect="dark" style="width: 100%" >
                <!-- <el-table-column type="selection" width="35">
                </el-table-column> -->
                <el-table-column label="序号">
                    <template slot-scope="scope">{{total-((searchObj.page-1)*searchObj.num+ scope.$index) }}</template>
                </el-table-column>
                <el-table-column label="受邀请人姓名">
                    <template slot-scope="scope">{{ scope.row.userRealname }}</template>
                </el-table-column>
                <el-table-column label="受邀时间">
                    <template slot-scope="scope">{{ scope.row.inviteTime }}</template>
                </el-table-column>
                <el-table-column label="受邀渠道">
                    <template slot-scope="scope">{{ scope.row.inviteSource |turnValToText("invite_resource") }}</template>
                </el-table-column>
               <!-- <el-table-column label="操作" >
                    <template slot-scope="scope">
                        <div style="text-align: center;">
                            <span class="spanBtn" @click="toDetail(scope.row)">详情</span>
                        </div>
                    </template>
                </el-table-column> -->
            </el-table>
        </div>
        <div class="pageBox">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="searchObj.page"
                :page-size.sync="searchObj.num" layout="total, sizes, prev, pager, next, jumper" :total="total"
                background>
            </el-pagination>
        </div>

    </div>
</template>

<script>
    import {        json,       wordData,        utils    } from '@/common/common.js'
    import {        ajaxPost,api    } from '@/common/request.js'
// 
    export default {
        name: 'HelloWorld',
        data() {
            return {
                conferenceId:'',
                userId:'',
                userName:'',
                isLoading:false,
                tableData:[],
                formObj:{
                    fuzzyQuery:'',
                    userType:'',
                    authResult:'',
                    systemResult:'',
                },
                searchObj: {
                    page: 1,
                    num: 10,
                },
                total:0,
            }
        },
        components: {
        },
        computed: {
            IMG_PREV() {
                return api.imgPrev
            },
            userTypeOptions() {
                return wordData.user_type
            },
            authResultOptions() {
                return wordData.auth_result
            },
            
        },
        methods: {
            getParams() {
                this.conferenceId = this.$route.params.conferenceId
                this.userId = this.$route.params.userId
                this.userName = this.$route.params.userName
            },
            fuzzySearchClick() {
                this.searchObj = {
                    fuzzyQuery: this.formObj.fuzzyQuery,
                    num: this.searchObj.num,
                    page: 1,
                }
                this.getTableLists()
            },
            multiSearchClick() {
                this.searchObj = {
                    authResult: this.formObj.authResult,
                    userType: this.formObj.userType,
                    systemResult:this.formObj.systemResult,
                    num: this.searchObj.num,
                    page: 1,
                }
                this.getTableLists()
            },
            handleSizeChange(size) { //分页：每页n条
                this.searchObj.num = size
                this.searchObj.page = 1
                this.getTableLists()
            },
            handleCurrentChange(page) { //分页：改变第n页
                this.searchObj.page = page
                this.getTableLists()
            },
            getTableLists(){
                let _this=this
                let arg=JSON.parse(JSON.stringify( _this.searchObj))
                arg.conferenceId=_this.conferenceId
                arg.userId=_this.userId
                ajaxPost('/admin/getinviteDetail',arg).then(function(res) {
                    _this.tableData=res.data
                    _this.total=parseInt(res.data.total) 
                    _this.customerTotal=res.data.total
                }, function(res) {
                
                })
            },
            toDetail(list) {
                this.$router.push({name: 'activeInnerBuyerDetail',params: { userId: 1 }})
            },
        },
        mounted(){
           this.getParams()
           this.getTableLists()
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss">
    // *{outline: 1px solid blue;}
    .buyerInviteDetailWrap {
        padding-right:400px;
      background: #fff;
       .searchBox {
           padding: 0.25rem 0.25rem 0;
       
           .left {
               float: left;
           }
       
           .right {
             float:right;
           }
       }
       
       .searchBox:after {
           content: "";
           display: block;
           clear: both;
       }
       .tableBox{
           padding:0 10px;
       }
       
    }
</style>



// WEBPACK FOOTER //
// src/pages/active/innerPage/buyerInviteDetail.vue